module.exports = __webpack_public_path__ + "frontend/img/icon_close.a182f04c.svg";